import { useController, useFormContext } from 'react-hook-form';

import SimpleCheckbox from '../questions/simpleQuestions/SimpleCheckbox';
import { useQuestionLibraryStore } from '../store/questionLibraryStore';
import buildRules from '../utils/buildRules';
import { getError } from '../utils/errorHandling';
import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';

export default function CheckboxController({
  question,
  isParentShowing = true,
  padding = '0',
}) {
  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext();
  const { isVisible } = useConditionsEvaluator(question.conditions ?? {});
  const isShowing = isVisible && isParentShowing;
  const isAiHidden =
    useQuestionLibraryStore((s) => s.screenData?.isAiHiddenByQuestion)?.[
      question.name
    ] === true;
  const { field } = useController({
    name: question.name,
    control,
    rules: buildRules(question, isShowing),
    defaultValue: getValues()[question.name],
  });

  if (isAiHidden) {
    return null;
  }

  return (
    <SimpleCheckbox
      field={field}
      question={question}
      error={getError(errors, question.name)}
      padding={padding}
    />
  );
}
